export default __webpack_public_path__ + "assets/img/ict-select.3a2cbf8780b96eafa468b422b5360a6e.svg";